import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';

import './index.scss';
import IntroBanner from '../../components/IntroBanner/introBanner';
import BilateralContainerLayout from '../../components/Bilateral/BilateralContainerLayout/bilateralContainerLayout';
import { BilateralContainerLayoutStyleListTypes } from '../../utils/utils';
import informationData from '../../normalization/information';
import TextComponent from '../../components/TextComponent/textComponent';
import BilateralBlock from '../../components/Bilateral/BilateralBlock/bilateralBlock';
import BilateralImage from '../../components/Bilateral/BilateralImage/bilateralImage';

export const query = graphql`
  query InformationSitePageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const Information = (props) => {
  const { heroIntro, bilateralContainer } = informationData();
  const { data } = props;
  const { site } = data || {};

  return (
    <LayoutContainer>
      <SEO title={`${site.title} | Information`} description={site.description} keywords={site.keywords} />
      <IntroBanner
        heroBannerImage={heroIntro.bannerImg}
        headlineText={heroIntro.headlineText}
        description={heroIntro.description}
        layoutStyle={heroIntro.className}
      />
      <BilateralContainerLayout layoutStyle={BilateralContainerLayoutStyleListTypes.BILATERALSTYLE3}>
        {bilateralContainer.bilateralList.map((block) => (
          <BilateralBlock key={Math.random().toString(36).substring(7)} layoutStyle={block.className}>
            <TextComponent
              heading={block.textComponent.headline}
              description={block.textComponent.description}
              linksBtn={block.textComponent.links.data}
              layoutStyle={block.textComponent.className}
              eyebrow={block.textComponent.eyebrow}
            />
            {block.bilateralImage && <BilateralImage src={block.bilateralImage.webUrl} alt={block.bilateralImage.alt} />}
          </BilateralBlock>
        ))}
      </BilateralContainerLayout>
    </LayoutContainer>
  );
};
export default Information;
